import styles from "./RelatorioColetas.module.css";
import "./Print.css";

function RelatorioColetas({
  tipoColeta,
  codigo,
  empresa,
  endereco,
  pagamento,
  contato,
  telefones,
  data,
  motorista,
  observacao,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.container_infos}>
        <div className={styles.cabecalho}>
          <h1>{tipoColeta || ""}</h1>
          <span>Código: {codigo}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Empresa:</span>
          <span>{empresa}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Forma Pagto.:</span>
          <span>{pagamento}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Endereço:</span>
          <span>{endereco || ""}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Contato:</span>{" "}
          <span>{contato || ""}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Telefones:</span>
          <span>{telefones || ""}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Data:</span>{" "}
          <span>{data || ""}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Observação:</span>
          <span>{observacao || ""}</span>
        </div>
        <div>
          <span className={styles.subtitle}>Motorista:</span>
          <span>{motorista || ""}</span>
        </div>
      </div>

      <footer>tel 11 9982-1188 www.giglio.com.br</footer>
    </div>
  );
}

export default RelatorioColetas;
